import StarCard from "@/components/base/StarCard";
import SectionHeading from "@/components/base/SectionHeading";
import type { Article } from "@/mocks/articles";

interface StarHighlightsProps {
  articles: Article[];
}

export default function StarHighlights({ articles }: StarHighlightsProps) {
  return (
    <section aria-label="明星动态精选">
      <SectionHeading
        eyebrow="STARS"
        icon="ri-star-smile-fill"
        title="明星动态精选"
        description="关注演员、歌手与创作者的近期动向与作品计划。"
        actionTo="/category/stars"
        actionLabel="全部动态"
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {articles.map((article) => (
          <StarCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}